module.exports = __webpack_public_path__ + "static/media/OG-BNB.c7badad8.svg";